import { Box, Button, Stack, Tabs } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewConsignmentFormValues } from '@e-origin/contracts';
import { TSDConsignmentItem } from '@e-origin/shared';

import { classes } from '@styles';
import { GoodsItemData } from './GoodsItemData';
import { GoodsItemDocuments } from './GoodsItemDocuments';
import { GoodsItemStakeholders } from './GoodsItemStakeholders';
import { GoodsItemTransport } from './GoodsItemTransport';
import { useTSDViewEditGoodsItemFormInitializer } from './useTSDViewEditGoodsItemFormInitializer';

interface EditGoodsItemProps {
  consignmentForm: UseFormReturnType<TSDViewConsignmentFormValues>;
  goodsItemIdx: number;
  houseConsignmentIdx: number;
  isMaster: boolean;
  onHide: () => void;
  onSave: (goodsItem: TSDConsignmentItem) => void;
  disabled: boolean;
}

export const EditGoodsItem: React.FC<EditGoodsItemProps> = ({ houseConsignmentIdx, isMaster, goodsItemIdx, onSave, onHide, disabled, consignmentForm }) => {
  const { goodsItemForm, onSubmit } = useTSDViewEditGoodsItemFormInitializer({
    houseConsignmentIdx,
    isMaster,
    goodsItemIdx,
    consignmentForm,
    onSave,
    onHide,
  });

  return (
    <Stack px="md">
      <Tabs defaultValue="item-data">
        <Tabs.List>
          <Tabs.Tab value="item-data">Item Data</Tabs.Tab>
          <Tabs.Tab value="stakeholders">Stakeholders</Tabs.Tab>
          <Tabs.Tab value="transport">Transport</Tabs.Tab>
          <Tabs.Tab value="documents">Documents</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="item-data">
          <GoodsItemData goodsItemForm={goodsItemForm} disabled={disabled} />
        </Tabs.Panel>

        <Tabs.Panel value="stakeholders">
          <GoodsItemStakeholders goodsItemForm={goodsItemForm} disabled={disabled} />
        </Tabs.Panel>

        <Tabs.Panel value="transport">
          <GoodsItemTransport goodsItemForm={goodsItemForm} disabled={disabled} />
        </Tabs.Panel>

        <Tabs.Panel value="documents">
          <GoodsItemDocuments goodsItemForm={goodsItemForm} disabled={disabled} />
        </Tabs.Panel>
      </Tabs>
      <Box className={classes.footer}>
        <Button type="button" onClick={onHide} size="lg" variant="transparent">
          Cancel
        </Button>
        {!disabled && (
          <Button type="button" onClick={onSubmit} variant="filled" size="lg" data-pw="save-goods-item-btn">
            Save
          </Button>
        )}
      </Box>
    </Stack>
  );
};
